import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Popover } from '@thoughtspot/radiant-react/widgets/popover';
import { SearchBar } from '@thoughtspot/radiant-react/widgets/search-bar';
import React, { useRef, useState } from 'react';
import styles from './orgs-list.module.scss';
const MAX_VISIBLE_ORGS = 5;
const MAX_ORG_NAME_LENGTH = 12;
const truncateOrgName = (name) => name.length > MAX_ORG_NAME_LENGTH
    ? `${name.slice(0, MAX_ORG_NAME_LENGTH)}...`
    : name;
export const OrgsList = ({ orgs }) => {
    const popoverRef = useRef(null);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [popoverSearch, setPopoverSearch] = useState('');
    if (!orgs || orgs.length === 0)
        return null;
    const visible = orgs.slice(0, MAX_VISIBLE_ORGS);
    const overflow = orgs.slice(MAX_VISIBLE_ORGS);
    const showSearch = overflow.length > 20;
    const showScroll = overflow.length > 7;
    const filteredOverflow = popoverSearch
        ? overflow.filter(o => o.toLowerCase().includes(popoverSearch.toLowerCase()))
        : overflow;
    return (React.createElement("span", { className: styles.orgsList },
        React.createElement("span", { className: styles.orgsListText }, visible.map((org, idx) => (React.createElement(React.Fragment, { key: org },
            idx > 0 && ', ',
            React.createElement("span", { className: styles.orgName, ...(org.length > MAX_ORG_NAME_LENGTH && {
                    'data-tooltip-content': org,
                    'data-tooltip-align': 'center',
                    'data-tooltip-position': 'bottom',
                }) }, truncateOrgName(org)))))),
        overflow.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement("span", { ref: popoverRef, className: styles.orgsListMore },
                React.createElement(Button, { type: "tertiary", size: "m", text: `+${overflow.length} more`, className: styles.moreOrgs, onClick: () => {
                        setIsPopoverOpen(!isPopoverOpen);
                        setPopoverSearch('');
                    } })),
            React.createElement(Popover, { align: "bottom-start", content: React.createElement("div", { className: styles.overflowTagsPopover },
                    showSearch && (React.createElement("div", { className: styles.popoverSearchWrapper },
                        React.createElement(SearchBar, { searchValue: popoverSearch, searchPlaceholder: "Search", onSearchChange: setPopoverSearch }))),
                    React.createElement("div", { className: showScroll
                            ? styles.popoverOrgListScrollable
                            : styles.popoverOrgList }, filteredOverflow.length > 0 ? (filteredOverflow.map(org => (React.createElement("span", { key: org, className: styles.orgTag, "data-tooltip-content": org, "data-tooltip-align": "center", "data-tooltip-position": "right" }, org)))) : (React.createElement("span", { className: styles.popoverNoResults }, "No results")))), targetRef: popoverRef, isVisible: isPopoverOpen, onClickOutside: () => {
                    setIsPopoverOpen(false);
                    setPopoverSearch('');
                } })))));
};
//# sourceMappingURL=orgs-list.js.map